import { TOOLBAR_ICON_CLICK, TOOLBAR_OUTSIDE_CLICK } from './constants'

export const toolbarIconClick = (name, id, module) => ({
    type: TOOLBAR_ICON_CLICK,
    data: { name, id, module },
})

export function toolbarOutsideClick(uniqueId, module) {
    return {
        type: TOOLBAR_OUTSIDE_CLICK,
        data: {
            uniqueId,
            module,
        },
    }
}
